import {ProductCatalog as NewProductCatalog} from '@/features/ProductCatalog/ProductCatalog'
import {ProductCatalog} from '@/pages/Content/ProductCatalog' 
import {selectCountryCode} from '@/store/slices/countryCodeSlice'
import {NEW_THEME_FEATURE_COUNTRIES} from '@/utils/constants/marketFeatureCountries'
import {useSelector} from 'react-redux'

const ProductCatalogByMarket = () => {
  const countryCode = useSelector(selectCountryCode)

  if (NEW_THEME_FEATURE_COUNTRIES.includes(countryCode)) {
    return <NewProductCatalog />
  }

  return <ProductCatalog/>
}

export default ProductCatalogByMarket